/**
 * Bug #452
 * @Author Santhosh Kumar
 * @Date 21 June 2021
 */
 import axios from "axios";
 import { SAVE_FCM_TOKEN } from 'api/endpoint';
 
 export const saveFcmToken = (data) => {
   //console.log(data);
   return axios.post(SAVE_FCM_TOKEN, data);
 };
 /*** End ***/